module.exports = {"510623100":"凯江镇","510623101":"南华镇","510623102":"回龙镇","510623103":"通济镇","510623104":"永太镇","510623105":"黄鹿镇","510623106":"集凤镇","510623107":"富兴镇","510623108":"辑庆镇","510623109":"兴隆镇","510623110":"龙台镇","510623111":"永安镇","510623113":"玉兴镇","510623114":"永兴镇","510623115":"悦来镇","510623116":"继光镇","510623117":"仓山镇","510623118":"广福镇","510623119":"会龙镇","510623120":"万福镇","510623121":"普兴镇","510623122":"联合镇","510623123":"冯店镇","510623124":"积金镇","510623125":"太安镇","510623132":"东北镇","510623206":"柏树乡","510623207":"白果乡","510623214":"永丰乡","510623218":"通山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510623.json
// module id = 2425
// module chunks = 0